export const viewModes = {
    Collapse: "resultsLayout_Collapse",
    Grid: "resultsLayout_Grid",
    List: "resultsLayout_List"
}